const DEBOUNCES_STATE = {}

export default (fn, milliseconds) => (...args) => {
  if (typeof fn !== 'function') {
    throw new Error('debouce require only function')
  }

  const key = fn.name
  const DEFAULT_TIME = 1000
  if (DEBOUNCES_STATE[key]) {
    clearTimeout(DEBOUNCES_STATE[key])
  }

  DEBOUNCES_STATE[key] = setTimeout(
    () => fn(...args),
    milliseconds || DEFAULT_TIME
  )
}
